<template>
  <div>
    <v-container grid-list-md fluid>
      <v-layout wrap>
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <span style="color:#0cabc2">DO detail</span>
                </v-toolbar-title>
              </v-toolbar>
              <v-layout wrap>
                <v-flex xs4>
                  <v-card color="white">
                    <v-card-title class="pb-0">
                      <div class="subheading">Date :</div>
                      <h3>{{do_created_date}}</h3>
                    </v-card-title>
                    <v-card-title class="pb-0">
                      <div class="subheading">Customer :</div>
                      <h3>{{customer_name}}</h3>
                    </v-card-title>
                    <v-card-title>
                      <div class="subheading">Driver :</div>
                      <h3>{{deliver_driver_name}}</h3>
                    </v-card-title>
                    <v-card-title>
                      <div class="subheading">Sewa price :</div>
                      <h3>{{sprice}}</h3>
                    </v-card-title>
                  </v-card>
                </v-flex>
                <v-flex xs2>
                  <v-btn
                    color="primary"
                    :loading="saving"
                    :disabled="saving"
                    @click="dialog_change_detail=true"
                  >Change</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <span style="color:#0cabc2">Adjust Basket quantity in this DO</span>
                </v-toolbar-title>
              </v-toolbar>
              <v-flex xs4>
                <v-text-field
                  v-model="basket_quantity"
                  v-on:change="basket_quantity = Math.max(Math.min(Math.round(basket_quantity), 9999999), 0)"
                  ref="basket_q"
                  type="number"
                  label="Empty Basket returned by customer (may ingore)"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-btn
                  color="primary"
                  :loading="saving"
                  :disabled="saving"
                  @click="update_basket()"
                >Update Basket Only</v-btn>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <span style="color:#0cabc2">Add Stock</span>
                  <span style="color:#0cabc2">(Total: RM{{parseFloat(total_amount).toFixed(2)}})</span>
                </v-toolbar-title>
              </v-toolbar>
              <!--  insert item into DO -->
              <v-layout wrap row>
                <!--  Select Product -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="product"
                    :items="productList"
                    item-text="product_code_name"
                    item-value="id"
                    v-on:keyup.enter="getAvailableStock(),clearallfield(),VegeNext(),checkingProudctType()"
                    v-on:change="clearallfield(),getAvailableStock(),checkingProudctType()"
                    label="Vege"
                    ref="product"
                    chips
                    return-object
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ item.product_code_name }} &nbsp; &nbsp;
                      <v-avatar size="38">
                        <img :src="(baseUrl+'/product/vege_img/'+item.picture)" />
                      </v-avatar>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <!--  Select Stock -->
                <v-flex xs2 v-if="limitDay != '0' ">
                  <v-select
                    v-model="available_stock"
                    :items="available_stockList"
                    item-text="date"
                    v-on:keyup.enter="AvailbleStockNext()"
                    label="Availble Stock"
                    ref="available_stock"
                    chips
                    return-object
                  >
                    <template slot="selection" slot-scope="{ item }">
                      {{ item.date }} &nbsp;
                      {{ item.available_weight }}kg
                    </template>
                    <template slot="item" slot-scope="{ item }">
                      {{ item.date }} &nbsp; &nbsp;
                      {{ item.available_weight }}kg
                    </template>
                  </v-select>
                </v-flex>

                <!--  Select Grade -->
                <v-flex xs1 v-if="setting_grade == true">
                  <v-autocomplete
                    v-model="grade"
                    :items="gradeList"
                    item-text="name"
                    item-value="name"
                    v-on:keyup.enter="GradeNext()"
                    label="Grade"
                    ref="grade"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!--  Select Location -->
                <v-flex xs1 v-if="setting_location == true">
                  <v-autocomplete
                    v-model="location"
                    :items="locationList"
                    v-on:keyup.enter="LocationNext()"
                    item-text="name"
                    item-value="name"
                    label="Location"
                    ref="location"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!-- Type Price -->
                <v-flex xs1 v-if="setting_price == true">
                  <v-text-field
                    v-model="price"
                    v-on:keyup.enter="PriceNext();"
                    v-on:change="price = Math.max(Math.min(price, 9999999), 0)"
                    ref="price"
                    type="number"
                    label="Price"
                    box
                  ></v-text-field>
                </v-flex>

                <!--  Type Weight -->
                <v-flex xs2>
                  <v-text-field
                    v-if="product_type_need_weight==true"
                    v-model="weight"
                    v-on:keyup.enter="WeightNext()"
                    @keydown.tab.prevent="tabNext()"
                    v-on:change="weight = Math.max(Math.min(weight, 9999999), 0.01)"
                    type="number"
                    ref="weight"
                    label="weight(kg)"
                    box
                  ></v-text-field>
                </v-flex>

                <!--  Type Quantity -->
                <v-flex xs1>
                  <v-text-field
                    v-model="quantity"
                    v-on:keyup.enter="QuantityNext()"
                    @keydown.tab.prevent="tabNext()"
                    v-on:change="quantity = Math.max(Math.min(Math.round(quantity), 9999999), 1)"
                    ref="qty"
                    type="number"
                    @focus="$event.target.select()"
                    label="Qty"
                    box
                  ></v-text-field>
                </v-flex>

                <!--  Select Basket  -->
                <v-flex xs1 v-if="product_type_need_basket === true">
                  <v-autocomplete
                    v-model="basket_need"
                    :items="basket_needList"
                    item-text="text"
                    item-value="value"
                    v-on:keyup.enter="BasketNext()"
                    label="Basket"
                    ref="basket"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs1>
                  <v-btn color="primary" @click="additemToDO(),tabNext()">
                    <v-icon>subdirectory_arrow_left</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-layout>
                     <v-flex xs7></v-flex>
                      <v-flex xs2>
                          <v-btn  dark @click="bulkupdatePrice()" color="green">
                              Update All Price
                          </v-btn>

                      </v-flex>
                </v-layout>
                <v-flex xs12>
                  <v-layout wrap row>
                  <v-flex >
                    <div style="text-align:center">
                     <v-progress-circular
                        indeterminate
                        :size="30"
                        color="primary"
                     
                        v-if="stock_loading"
                        style="margin-bottom:14px"
                      ></v-progress-circular>

                         <v-pagination
                  v-model="stock_page"
                  :length="stock_length"
                ></v-pagination>
                </div>
                  </v-flex>
                </v-layout>
                  <v-data-table
                    :headers="headers"
                    :items="stock"
                    :search="search"
                    disable-initial-sort
                    hide-actions
                    :rows-per-page-items="[100, 150, 200, 250]"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          <v-avatar size="38">
                            <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
                          </v-avatar>
                        </td>
                        <td class="text-xs-right">{{ props.item.product_name }}</td>
                        <td class="text-xs-right">{{ props.item.grade }}</td>
                        <td class="text-xs-right">{{ props.item.location }}</td>
                        <td class="text-xs-right">{{ props.item.weight }}</td>
                        <td class="text-xs-right">{{ props.item.quantity }}</td>

                        <td class="text-xs-right">
                          <v-text-field
                            v-model="props.item.price"
                            label="price"
                            type="number"
                            @focus="$event.target.select()"
                          ></v-text-field>
                        </td>
                              <!-- v-on:change="DebounceUpdatePrice(props.item.id,props.item.price)"
                            :placeholder="props.item.price" -->

                        <td class="text-xs-right">{{ props.item.product_stocked_date }}</td>
                        <td class="text-xs-right">{{ props.item.basket }}</td>
                        <td class="text-xs-right">RM{{props.item.amount }}</td>

                        <td class="justify-end layout px-5">
                          <v-icon medium color="primary" @click="open_split_dialog(props.item.quantity,props.item.id)" >build</v-icon>
                          <v-icon medium color="warning" @click="editItem(props.item.id)">build</v-icon>
                          <v-icon
                            medium
                            color="error"
                            @click="deleteItem(props.item)"
                          >delete_forever</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                   <v-layout wrap row>
                  <v-flex >
                    <div style="text-align:center">
                     <v-progress-circular
                        indeterminate
                        :size="30"
                        color="primary"
                     
                        v-if="stock_loading"
                        style="margin-bottom:14px"
                      ></v-progress-circular>

                         <v-pagination
                  v-model="stock_page"
                  :length="stock_length"
                ></v-pagination>
                </div>
                  </v-flex>
                </v-layout>
                </v-flex>
                <v-layout>
                     <v-flex xs7></v-flex>
                      <v-flex xs2>
                          <v-btn  dark @click="bulkupdatePrice()" color="green">
                              Update All Price
                          </v-btn>

                      </v-flex>
                </v-layout>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- <v-layout row wrap>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="stock"
            :search="search"
            disable-initial-sort
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>
                  <v-avatar size="38">
                    <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
                  </v-avatar>
                </td>
                <td class="text-xs-right">{{ props.item.product_name }}</td>
                <td class="text-xs-right">{{ props.item.grade }}</td>
                <td class="text-xs-right">{{ props.item.location }}</td>
                <td class="text-xs-right">{{ props.item.weight }}</td>
                <td class="text-xs-right">{{ props.item.quantity }}</td>

                <td class="text-xs-right">
                  <v-text-field
                    v-model="props.item.price"
                    label="price"
                    v-on:change="DebounceUpdatePrice(props.item.id,props.item.price)"
                    type="number"
                    :placeholder="props.item.price"
                    @focus="$event.target.select()"
                  ></v-text-field>
                </td>

                <td class="text-xs-right">{{ props.item.product_stocked_date }}</td>

                <td class="justify-end layout px-5">
                  <v-icon medium color="warning" @click="editItem(props.item.id)">build</v-icon>
                  <v-icon medium color="error" @click="deleteItem(props.item)">delete_forever</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>-->
    </v-container>

    <v-dialog v-model="dialog_edit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit item</span>
        </v-card-title>

        <v-card-text>
          <edit_dialog ref="edit" @update="getDOStock(do_id,do_date,customer_id,stock_page)"></edit_dialog>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_change_detail" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Change</span>
        </v-card-title>
        <v-card-text>
          <v-flex xs11>
            <v-menu
              lazy
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                label="Date"
                v-model="do_created_date"
                persistent-hint
                outline
                readonly
              ></v-text-field>

              <v-date-picker v-model="do_created_date" no-title actions></v-date-picker>
            </v-menu>
          </v-flex>
          <!-- customer selection  -->
          <v-flex xs11>
            <v-autocomplete
              v-model="customer_id"
              :items="customerList"
              item-text="name"
              item-value="id"
              label="Customer"
              persistent-hint
              small-chips
              outline
            ></v-autocomplete>
          </v-flex>

          <!-- delivery driver selection  -->
          <v-flex xs11>
            <v-autocomplete
              v-model="deliver_driver_id"
              :items="deliverydriverList"
              item-text="username"
              item-value="id"
              label="Delivery by (may leave blank)"
              persistent-hint
              small-chips
              outline
            ></v-autocomplete>
          </v-flex>
          <v-flex xs11>
            <v-text-field outline type="number" label="sewa price" v-model="sewa_price"></v-text-field>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-btn flat @click="updateDoDetail()">Save</v-btn>
          <v-btn flat @click="dialog_change_detail=false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="split_dialog" max-width="400px">
        <v-card>
          <v-card-title>Split (cannot more then{{max_split_quantity-1}})</v-card-title>
          <v-card-text>
             <v-text-field
            label="Split quantity"
            v-model="split_quantity"
            v-on:change="split_quantity = Math.max(Math.min(split_quantity, max_split_quantity-1), 1)"
            outline
          ></v-text-field>
          </v-card-text>
            <v-card-actions>
          <v-btn flat @click="split_qty()">Save</v-btn>
          <v-btn flat @click="split_dialog=false">close</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :top="true" :timeout="10000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="2500">
      {{response}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="1500">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import edit_dialog from "@/components/large_component/edit_dialog";
import moment from "moment";
import { debounce } from "lodash";

export default {
  components: {
    edit_dialog
  },
  data: () => ({
    search: "",
    snackbar: false,
    dialog: false,
    saving: false,
    errors: "",
    baseUrl: baseUrl,
    dialog_edit: false,
    basket_needList: [
      { text: "basket", value: true },
      { text: "no basket", value: false }
    ],
    headers: [
      {
        text: "Image",
        value: "product_image"
      },

      { text: "Veg", align: "right", value: "product_name" },
      { text: "Grade", align: "right", value: "grade" },
      { text: "Location", align: "right", value: "location" },
      { text: "Weight", align: "right", value: "weight" },
      { text: "Qty", align: "right", value: "quantity" },
      { text: "Price", align: "right", value: "price" ,sortable: false},
      { text: "Veg date", align: "right", value: "product_stocked_date" },
      { text: "Basket?", align: "right", value: "basket" },
      { text: "Amount", align: "right", value: "amount" },

      { text: "Actions", align: "right", value: "id", sortable: false }
    ],
    stock: [],
    selected_farmer: "",
    selected_po_id: "",
    snackbar_response: false,
    response: "",
    type_need_weight: false,
    //logic control
    product_type_need_weight: true,
    product_type_need_basket: true,
    setting_grade: true,
    setting_location: true,
    setting_price: true,
    limitDay: "",

    date: moment().format("YYYY-MM-DD"),
    do_date: "",
    do_id: "",
    product: "",
    available_stock: "",
    weight: "",
    quantity: "",
    price: "",
    limitDay: "",
    grade: "unknown",
    location: "unknown",
    basket_quantity: "",
    basket_added_before: false,
    total_amount: "",

    customer_name: "",
    customer_id: "",
    test: "",
    basket: true,
    basket_need: "",

    deliver_driver_name: "",
    deliver_driver_id: "",
    do_created_date: "",
    sewa_price: "",
    sprice: "",
    dialog_change_detail: false,
    deliverydriverList: [],
    customerList: [],

    productList: [],
    gradeList: [],
    locationList: [],
    available_stockList: [],
    // dialog snackbar date_box
    setting_dialog: false,
    date_box: false,
    vege_adding_loading_dialog: false,
    snackbar_response: false,
    snackbar_no_connection: false,
    //others
    response_detail: "",
    vege_adding_loading_value: "",
    spli_dialog:false,
    max_split_quantity:"",
    split_quantity:"",
    split_stock_id:"",
    stock_page:1,
    stock_length:1,
    stock_loading:false,
  }),

  computed: {},

  watch: {
    dialog(val) {
      val || this.close();
    },
    "props.item.price"(np) {
      console.log(np);
    },
    stock_page(e){
      this.getDOStock(this.do_id, this.do_date, this.customer_id,e);

    }
  },
  mounted() {
    this.intervalFetch();
  },

  created() {
    this.stock_page=1;
    this.getProduct();
    this.getCustomer();
    this.getDeliveryDriver();
    this.getGrade();
    this.getLocation();
    this.debouncedGetAnswer = _.debounce(this.getAnswer, 500);
  },

  methods: {
    getCustomer() {
      const params = new URLSearchParams();
      params.append("get_customer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_customer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.customerList = response.data.data;
            console.log("Customer List hahahahaa");
            console.log(response.data.data);
          } else if (response.data.error == true) {
            console.log("Customer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getDeliveryDriver() {
      const params = new URLSearchParams();
      params.append("get_driver", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_driver.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.deliverydriverList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Delivery Driver List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getDOStock(do_id, do_date, customer_id,page) {
      this.total_amount = 0;
      this.dialog_edit = false;
      this.do_id = do_id;
      this.do_date = do_date;
      this.customer_id = parseFloat(customer_id);
      this.get_basket();
      this.getDODetail();

      this.stock_page=page;;
      this.stock_loading=true;

      const params = new URLSearchParams();

      params.append("getDOStock", "getDOStock");
      params.append("do_id", do_id);
      params.append("page", this.stock_page);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order2.php",
        data: params
      })
        .then(response => {
          console.log(response);
      this.stock_loading=false;
          if (response.data.error == false) {
            this.stock_length = response.data.length;
            this.stock = response.data.data;
            this.total_amount =response.data.total_price;


            for (var i = 0; i < this.stock.length; i++) {
              var row_amount =
                this.stock[i].real_weight *
                this.stock[i].price *
                this.stock[i].quantity;

              this.$set(
                this.stock[i],
                "amount",
                parseFloat(row_amount).toFixed(2)
              );
              // this.total_amount += row_amount;

              if (parseFloat(this.stock[i].basket_item_quantity) > 0) {
                this.$set(this.stock[i], "basket", "basket");
              } else {
                this.$set(this.stock[i], "basket", "no basket");
              }
            }
          } else if (response.data.error == true) {
             this.stock_length = 1;
            this.errors = response.data.message;
            this.stock = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    getDODetail() {
      const params = new URLSearchParams();

      params.append("getDODetail", "getDODetail");
      params.append("do_id", this.do_id);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          console.log("whyuuuuuuu");
          console.log(response.data.data);

          if (response.data.error == false) {
            var do_detail = response.data.data;
            this.customer_name = do_detail[0].customer_name;
            this.deliver_driver_name = do_detail[0].deliver_driver_name;
            this.do_created_date = do_detail[0].created_at;
            // this.test = do_detail[0].customer_id;
            this.deliver_driver_id = do_detail[0].deliver_driver_id;
            this.sprice = do_detail[0].sewa_price;
            this.sewa_price = do_detail[0].sewa_price;
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.stock = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    updateDoDetail() {
      const params = new URLSearchParams();

      params.append("updateDoDetail", "updateDoDetail");
      params.append("do_id", this.do_id);
      params.append("customer_id", this.customer_id);
      params.append("deliver_driver_id", this.deliver_driver_id);
      params.append("date", this.do_created_date);
      params.append("sewa_price", this.sewa_price);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.getDOStock(this.do_id, this.do_created_date, this.customer_id,this.stock_page);
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.dialog_change_detail = false;

            this.$emit("update", "someValue");
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    deleteItem(item) {
      const params = new URLSearchParams();
      params.append("deleteDOStock", "deleteDOStock");
      params.append("id", item.id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.getDOStock(this.do_id, this.do_date, this.customer_id,this.stock_page);
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    getGrade() {
      const params = new URLSearchParams();
      params.append("get_grade", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.gradeList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Grade List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getLocation() {
      const params = new URLSearchParams();
      params.append("get_location", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.locationList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Location List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    additemToDO() {
      //checking whether data filled
      if (this.weight != null && this.quantity != null) {
        console.log("Weight");
        console.log(this.weight);
        if (this.grade == "") {
          this.grade = "unknown";
        }
        if (this.location == "") {
          this.location = "unknown";
        }
        if (this.price == "") {
          this.price = "0";
        }
        const params = new URLSearchParams();
        params.append("additemToDO", "additemToDO");
        params.append("date", this.do_date);
        params.append("do_id", this.do_id);
        params.append("product_id", this.product.id);
        params.append("type", this.product.type);
        params.append("product_stocked_date", this.available_stock.date);
        params.append("weight", this.weight);
        params.append("grade", this.grade);
        params.append("location", this.location);
        params.append("quantity", this.quantity);
        params.append("price", this.price);
        params.append("customer_id", this.customer_id);
        params.append("basket", (this.basket_need==true?'1':'0'));
        console.log("hahahaa");
        console.log(this.basket_need);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
          data: params
        })
          .then(response => {
        console.log(response);

            if (response.data.error == false) {
              //set response to selected data

              // this.product = "";

              this.getDOStock(this.do_id, this.do_date, this.customer_id,this.stock_page);
            } else if (response.data.error == true) {
              this.snackbar_response = true;
              this.response_detail = response.data.message;
            }
          })
          .catch(error => {
            console.log(error);
            this.snackbar_connection = true;
          });
      } else {
        this.snackbar_response = true;
        this.response_detail = "Please fill in the detail";
      }
    },
    getProduct() {
      const params = new URLSearchParams();
      params.append("getAllProduct", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/product/product.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.productList = response.data.data;
            this.clearallfield();
          } else if (response.data.error == true) {
            console.log("Product List Problem" + response.data.message);
            this.clearallfield();
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getAvailableStock() {
      const params = new URLSearchParams();
      params.append(
        "getAvailableStockGroupByDate",
        "getAvailableStockGroupByDate"
      );
      params.append("product_id", this.product.id);
      params.append("limit_day", this.limitDay);
      params.append("date", this.do_date);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.available_stockList = response.data.data;
            this.VegeNext();
            this.snackbar_response = false;
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.available_stockList = [];

            // this.available_stock_with_selected_farmer = [];
            // this.picked_stock_with_do_and_vege = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    get_basket() {
      const params = new URLSearchParams();
      params.append("readDOBasket", "readDOBasket");
      params.append("do_id", this.do_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            var quantity = [];
            quantity = response.data.data;

            for (var g = 0; g < quantity.length; g++) {
              var basket_q = quantity[g].quantity;
              this.basket_quantity = basket_q;
            }
            this.basket_added_before = true;
          } else if (response.data.error == true) {
            this.basket_quantity = "";
            this.basket_added_before == false;
          }
          {
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    update_basket() {
      this.saving = true;
      const params = new URLSearchParams();

      if (this.basket_added_before) {
        params.append("update", "update");
      } else {
        params.append("create", "create");
      }
      params.append("do_id", this.do_id);
      params.append("customer_id", this.customer_id);
      params.append("quantity", this.basket_quantity);
      params.append("date", this.do_date);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params,
        header: {
          "content-type": "application/x-www-form-urlencoded"
        }
      })
        .then(response => {
          if (response.data.error == false) {
            this.getDOStock(this.do_id, this.do_date, this.customer_id,this.stock_page);
            this.snackbar_response = true;
            this.response_detail = "sucessful";
            this.basket_added_before = true;
            this.saving = false;
            this.$emit("update", "someValue");

          } else {
            this.snackbar_response = true;
            this.response_detail = "error";
            this.saving = false;
            this.$emit("update", "someValue");

          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
          this.saving = false;
        });
    },
    checkingProudctType() {
      //       if (this.product.type.trim() == "box") {
      //         this.product_type_need_basket = false;

      //         this.product_type_need_weight = false;

      //         this.weight = "1";
      //       } else {
      //         this.product_type_need_weight = true;
      //         this.product_type_need_basket = true;
      //         this.weight = "";
      //       }
      // /////////////////
      //       if (this.product.type.trim() == "non-basket") {
      //         this.product_type_need_basket = false;
      //         this.basket = false;
      //       } else {
      //         this.product_type_need_basket = true;
      //         this.basket = false;
      //       }

      if (this.product.type== "box" || this.product.type== "bag" || this.product.type== "pcs" || this.product.type == "pkt" ) {
        this.product_type_need_basket = false;
        this.basket_need = false;
        this.product_type_need_weight = false;
        this.basket = false;
        this.weight = "1";
      } else if (this.product.type == "non-basket") {
        this.product_type_need_basket = false;
        this.product_type_need_weight = true;
        this.basket_need = false;
        this.basket = false;
        this.weight = "";
      } else {
        this.product_type_need_basket = true;
        this.product_type_need_weight = true;
        this.basket_need = true;
        this.basket = true;
        this.weight = "";
      }
    },
    VegeNext_item() {
      if (this.limitDay != "0" && this.available_stockList.length > 0) {
        this.$refs.available_stock.focus();
        this.$refs.available_stock.activateMenu();
      } else if (this.setting_grade == true) {
        this.$refs.grade.activateMenu();
        this.$refs.grade.focus();
      } else if (this.setting_location == true) {
        this.$refs.location.focus();
        this.$refs.location.activateMenu();
      } else if (this.product.type == "box" || this.product.type == "bag" || this.product.type == "pcs"|| this.product.type == "pkt"){
        this.$refs.qty.focus();
      } else {
        this.$refs.weight.focus();
      }
    },
    VegeNext() {
      var self = this;
      setTimeout(function() {
        self.VegeNext_item();
      }, 200);
    },
    AvailbleStockNext() {
      if (this.setting_grade == true) {
        this.$refs.grade.focus();
        this.$refs.grade.activateMenu();
      } else if (this.setting_location == true) {
        this.$refs.location.focus();
        this.$refs.location.activateMenu();
      } else if (this.setting_price == true) {
        this.$refs.price.focus();
      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    GradeNext() {
      if (this.setting_location == true) {
        this.$refs.location.focus();
        this.$refs.location.activateMenu();
      } else if (this.setting_price == true) {
        this.$refs.price.focus();
      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    LocationNext() {
      if (this.setting_price == true) {
        this.$refs.price.focus();
      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    BasketNext() {
      // if (this.setting_price == true) {
      //   this.$refs.price.focus();
      // } else if (this.product_type_need_weight == true) {
      //   this.$refs.weight.focus();
      // } else {
      //   this.$refs.qty.focus();
      // }
    },
    PriceNext() {
      if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    WeightNext() {
      this.$refs.qty.focus();
    },
    QuantityNext() {
      this.additemToDO();
      if (this.product_type_need_weight == true) {
        this.weight = "";
        this.quantity = "1";
        this.$refs.weight.focus();
      } else {
        this.quantity = "";
        this.$refs.qty.focus();
      }
    },
    tabNext() {
      this.$refs.product.focus();
      this.$refs.product.activateMenu();
      this.product = "";
      this.available_stockList = [];
      this.available_stock = "";
      this.grade = "";
      this.location = "";
      this.basket_need = "";
      this.price = "";
      this.weight = "";
      this.quantity = "";
    },
    clearallfield() {
      this.available_stockList = [];
      this.available_stock = "";
      this.weight = "";
      this.quantity = "";
      this.price = "";
      this.grade = "";
      this.location = "";
    },
    DebounceUpdatePrice: _.debounce(function(id, price) {
      console.log("sucessful");
      this.updatePrice(id, price);
    }, 300),

    updatePrice(id, price) {
      console.log("fail");

      const params = new URLSearchParams();
      params.append("updatePrice", "updatePrice");
      params.append("id", id);
      params.append("price", price);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            // this.fetch_do_item();

            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.getDOStock(this.do_id, this.do_date, this.customer_id,this.stock_page);
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    bulkupdatePrice() {
      const params = new URLSearchParams();
      params.append("bulkupdatePrice", "bulkupdatePrice");
      // params.append("id", id);
      params.append("stock", JSON.stringify(this.stock));

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/customer_invoice.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
             this.getDOStock(this.do_id, this.do_date, this.customer_id,this.stock_page);
          } else if (response.data.error == true) {
            
            this.snackbar_response = true;
            this.response_detail = "Failed. Try reupdate";
             this.getDOStock(this.do_id, this.do_date, this.customer_id,this.stock_page);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    editItem(id) { 
      this.dialog_edit = true;
      this.$refs.edit.fetch_item(id,this.customer_id);
    },
    intervalFetch: function() {
      setInterval(() => {
        this.limitDay = localStorage.stocked_day_limit;
        this.setting_grade = localStorage.setting_grade;
        this.setting_location = localStorage.setting_location;
        this.setting_price = localStorage.setting_price;
        if (this.setting_grade == "true") {
          this.setting_grade = true;
        } else {
          this.setting_grade = false;
        }
        if (this.setting_location == "true") {
          this.setting_location = true;
        } else {
          this.setting_location = false;
        }

        if (this.setting_price == "true") {
          this.setting_price = true;
        } else {
          this.setting_price = false;
        }
      }, 500);
    },
    open_split_dialog(max_quantity, stock_id) {
      this.split_stock_id = stock_id;
      this.split_dialog = true;
      this.max_split_quantity = max_quantity;
    },
    split_qty() {
      const params = new URLSearchParams();
      params.append("do_split", "do_split");
      params.append("stock_id", this.split_stock_id);
      params.append("split_quantity", this.split_quantity);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_split.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.data;
            this.getDOStock(this.do_id, this.do_date, this.customer_id,this.stock_page);
            this.split_dialog = false;
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.data;
            this.getDOStock(this.do_id, this.do_date, this.customer_id,this.stock_page);
            this.split_dialog = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    }
  }
};
</script>

